import React, { useEffect } from 'react';
import ScrollReveal from '@/components/ScrollReveal';
import { useLang } from '@/i18n/LanguageContext';

const Privacy = () => {
  const { lang } = useLang();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <h1 className="text-3xl md:text-5xl font-bold text-slate-900 mb-8">
            {lang === 'en' ? 'Privacy Policy' : 'Política de Privacidad'}
          </h1>
          <div className="prose prose-slate prose-lg">
            <p>
              We respect your privacy and are committed to protecting your personal information.
            </p>
            <h3 className="text-xl font-bold mt-6 mb-2">Use of Information:</h3>
            <p>
              We use your phone number to send SMS messages regarding your inquiry and customer care related topics. Mobile phone information or opt-in data collected will not be shared, sold, or disclosed to third parties or affiliates for marketing purposes.
            </p>
            <h3 className="text-xl font-bold mt-6 mb-2">Opt-Out:</h3>
            <p>
              Reply "STOP" to unsubscribe or "HELP" for assistance.
            </p>
            <h3 className="text-xl font-bold mt-6 mb-2">Message Disclosures:</h3>
            <p>
              Message frequency varies. Message and data rates may apply.
            </p>
            <h3 className="text-xl font-bold mt-6 mb-2">Data Security:</h3>
            <p>
              Your data is protected and retained only as needed.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
};

export default Privacy;
